/**
 * Dependencies
 */

'use strict'

import { addClass, nodesToArray, svgRefresh, getElData } from './utils/helpers'
import { popup } from './utils/actions'

import expander from './controllers/expander'
import form from './controllers/form'
import membersList from './controllers/members-list'
import membersMap from './controllers/members-map'
import offCanvas from './controllers/off-canvas'
import searchBox from './controllers/search-box'

const controllers = {
  expander: expander,
  form: form,
  'members-list': membersList,
  'members-map': membersMap,
  'off-canvas': offCanvas,
  'search-box': searchBox,
}

const initialized = new WeakSet()

/**
 * Application initializer
 */
function init(root) {
  root = root || document.documentElement

  const controllersInDoc = nodesToArray(
    root.querySelectorAll('[data-controller]'),
  )

  controllersInDoc.forEach((el) => {
    if (initialized.has(el)) {
      throw new Error('Element has already been initialized')
    }

    const data = getElData(el)
    const name = data.controller

    if (controllers[name]) {
      const mod = new controllers[name](el, data)
      initialized.add(mod)
    } else {
      throw new Error('Controller ' + name + ' does not exist!')
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  init()

  svgRefresh()
})

window.onload = () => {
  addClass(document.documentElement, 'is-loaded')
}
